import React, { Fragment } from 'react'
import { Label } from '../../../components'
import { getKeyOfOpt, lookupOption, renderOptionList } from './optionUtils'

const ListBox = ({
  id,
  name,
  label,
  helpText,
  isList,
  value,
  context,
  rtOptions,
  onChange,
  optionKeyName,
  getOptionTextFn,
}) => {
  const valueArray = isList
    ? value.map(val => getKeyOfOpt(val, optionKeyName))
    : [getKeyOfOpt(value, optionKeyName)]
  
  /*
    Translate val (the current value of the selection variable, as far as the list box is concerned)
    into the actual value to be saved in the data context.
  */
  const localChange = (val, isMulti) => {
    const valIsHTMLCollection = Object.prototype.isPrototypeOf.call(HTMLCollection.prototype, val)
    if (!valIsHTMLCollection) throw new Error('Unexpected: list box value is not an HTMLCollection')
    if (isMulti) {
      const newArray = Array.prototype.map.call(val, selectedOption => lookupOption(selectedOption.value, rtOptions))
      return newArray.length ? newArray : null
    } // else single
    return (val.length === 0) ? null : lookupOption(val[0].value, rtOptions)
  }

  return (
    <Fragment>
      <Label name={name} label={label} helpText={helpText} forId={id}/>
      <select id={id}
              name={id}
              className="form-control"
              style={{ width: 'auto' }}
              multiple={true}
              value={valueArray}
              onChange={e => onChange(localChange(e.target.selectedOptions, isList))}
      >
        {renderOptionList(rtOptions, true, context, (opt, scope) => {
          const optKey = getKeyOfOpt(opt, optionKeyName)
          return (
            <option key={id + '|' + optKey} value={optKey}>
              {optKey && getOptionTextFn(opt, scope)}
            </option>
          )
        })}
      </select>
    </Fragment>
  )
}

export default ListBox
